import './button.scss';

import * as React from 'react';

import { cn } from '@/shared/lib/utils';

const buttonVariantClass = {
  native: 'btn--native',
  primary: 'btn--primary',
  secondary: 'btn--secondary',
  success: 'btn--success',
  error: 'btn--error',
} as const;

const buttonSizeClass = {
  sm: 'btn--size-sm',
  md: 'btn--size-md',
  lg: 'btn--size-lg',
  icon: 'btn--size-icon',
} as const;

export type ButtonVariant = keyof typeof buttonVariantClass;
export type ButtonSize = keyof typeof buttonSizeClass;

export interface ButtonProps extends React.ComponentProps<'button'> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  outline?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'native', size = 'md', outline = false, children, ...props }, ref) => {
    return (
      <button
        ref={ref}
        data-slot="button"
        className={cn(
          'btn',
          buttonVariantClass[variant],
          buttonSizeClass[size],
          outline && 'btn--outline',
          className,
        )}
        {...props}>
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';

export { Button };
